import model from '../models-v2/partner-staff';
import routeName from './route-name';


export default [
  {
    path: '/partner-staffs/staffs',
    name: routeName.partnerStaff.index,
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../pages/partner-staff/PartnerStaffTopRightSection.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Udziałowcy i zarząd', url: '/partner-staffs/staffs' },
        { title: 'Udziałowcy', url: '/partner-staffs/staffs' },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/partner-staffs/staffs/create',
    name: routeName.partnerStaff.store,
    component: () => import('../pages/partner-staff/PartnerStaffCreateView.vue'),
  },
  {
    path: '/partner-staffs/staffs/edit/:id(\\d+)',
    name: routeName.partnerStaff.edit,
    component: () => import('../pages/partner-staff/PartnerStaffEditView.vue'),
  },
];
